import { Search, X } from 'lucide-react'

/**
 * Airbnb-style centered search pill rendered at the top of the discovery pages,
 * directly below the Marketplace / Explore Creations / Upcoming Events tabs.
 * Presentational only — each page owns its query state and filtering.
 */
export function DiscoverySearchBar({
  value,
  onChange,
  placeholder,
  ariaLabel,
}: {
  value: string
  onChange: (value: string) => void
  placeholder: string
  ariaLabel: string
}) {
  return (
    <div className="mx-auto flex w-full max-w-xl items-center gap-2 rounded-full border border-stone-200 bg-white py-2 pl-6 pr-2 shadow-[0_3px_14px_rgba(28,25,23,0.10)] transition focus-within:border-[#8BA888] focus-within:shadow-[0_4px_20px_rgba(28,25,23,0.14)]">
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className="min-w-0 flex-1 bg-transparent text-sm text-stone-900 outline-none placeholder:text-stone-400"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-stone-400 transition hover:bg-stone-100 hover:text-stone-600"
        >
          <X className="h-4 w-4" />
        </button>
      ) : null}
      <span
        aria-hidden="true"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#496845] text-white"
      >
        <Search className="h-4 w-4" />
      </span>
    </div>
  )
}
